import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { BiCheckCircle, BiErrorCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
export const Toaster = ({ title, variant = "primary", currentState, handleToaster, delay = 5000 }) => {
  const navigate = useNavigate();
  return (
    <ToastContainer position="top-end">
      <Toast bg={variant.toLowerCase()} onClose={() => handleToaster()} show={currentState} delay={delay} autohide>
        <div className="info-container d-flex align-items-center">
          &nbsp;
          {variant.toLowerCase() === "success" ? (
            <BiCheckCircle className="info-icon ms-3 text-white fs-5" />
          ) : (
            <BiErrorCircle className="info-icon ms-3 text-white fs-5" />
          )}
          <Toast.Body className={`${variant.toLowerCase()} text-white`}>{title}</Toast.Body>
        </div>
      </Toast>
    </ToastContainer>
  );
};
